<template>
  <div class="container page lottery">
    <van-nav-bar title="打賞" class="nav-bar">
<!--            <template #right>-->
<!--              <div class="right" @click="showRight">{{ $t('reservation.switching_window') }}</div>-->
<!--            </template>-->
    </van-nav-bar>

    <div class="record">
      <div class="period">
        <span class="period-number">{{ lottery.now_expect  }}</span>
        <div class="next-number">
          <van-count-down :time="time" @finish="check()" />
        </div>
      </div>

      <div
          class="linear-gradient"
          style="
          background: linear-gradient(
            to right,
            rgba(126, 86, 120, 0),
            rgb(230, 195, 161),
            rgba(126, 86, 120, 0)
          );
        "
      ></div>

      <div class="history-entry-wrap">
        <div class="history-entry" @click="toggleHistory" style="display: none">
          <div class="history-result-left">{{ $t("reservation.win_num") || "投票结果" }}</div>

          <template v-if="latestResultItem">
            <span class="result-chip sum-chip">{{ getHistorySum(latestResultItem) }}</span>
            <span class="result-chip size-chip">{{ getHistorySizeLabel(latestResultItem) }}</span>
            <span class="result-chip odd-chip">{{ getHistoryOddEvenLabel(latestResultItem) }}</span>
          </template>

          <template v-else>
            <span class="result-chip waiting-chip">*****</span>
          </template>

          <div class="history-entry-right">
            <van-icon name="clock-o" class="history-clock-icon" />
          </div>
        </div>
      </div>
    </div>

    <div class="history_popup"></div>

    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div
              class="linear-gradient"
              style="
              background: linear-gradient(
                to right,
                rgba(126, 86, 120, 0),
                rgb(230, 195, 161),
                rgba(126, 86, 120, 0)
              );
            "
          ></div>

          <div class="sumValueTwoSides">
            <div
                class="rectangle large"
                :class="{ active: choose[v.type] }"
                v-for="(v, key) in lottery_peilv_list"
                :key="key"
                @click="choosePlay(v.type, v.name)"
            >
              <div class="wrapper">
                <div class="content">
                  <p class="name-text large">{{ displayPlayName(v.name) }}</p>
                  <p class="odd-text large">{{ v.proportion }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div class="item" @click="shopping ? (shopping = false) : (shopping = true)">
              <van-icon name="cart-o" class="jixuanico" />
            </div>
            <div class="line"></div>
          </div>

          <div class="mid">
            <span class="text" style="margin-right: 6px;">{{ $t("reservation.available_balance") }}:</span>
            <span class="text num" v-show="showBalance">{{ userInfo.money }}</span>
            <span class="text num" v-show="!showBalance">****</span>
            <van-icon
                :name="showBalance ? 'eye-o' : 'closed-eye'"
                @click="showBalance = !showBalance"
                style="margin-left: 10px; font-size: 16px;"
            />
          </div>

          <div class="right" @click="jiesuan()">
            {{ $t("reservation.submit") }}
          </div>
        </div>

        <div class="wrapper bet-panel" :class="{ active: shopping }">
          <div class="item">
            <span class="label">{{ $t("reservation.curr_choose") }}：</span>
            <div class="bet-number">{{ convertedShopchoose }}</div>
            <van-icon
                name="arrow-down"
                :class="{ up: shopping, down: !shopping }"
                @click="shopping ? (shopping = false) : (shopping = true)"
            />
          </div>

          <div class="item second-row">
            <span class="label">{{ $t("reservation.per_price") }}</span>
            <div class="amount-wrapper">
              <van-field
                  v-model="money"
                  type="digit"
                  :placeholder="$t('reservation.price_place')"
              />
            </div>
          </div>
        </div>
      </div>

      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <ui class="list">
            <li
                v-for="(v, key) in formData"
                :key="key"
                class="lise-item van-hairline--bottom"
            >
              <div class="main">
                <p class="bet-name">{{ displayPlayName(v.name) }}</p>
                <p class="detail-text">
                  1{{ $t("reservation.note") }}X{{ money }}{{ $t("reservation.unit") }}={{ money }}{{ $t("reservation.ge") }}
                </p>
              </div>
              <van-icon @click="clearChooes(v.type)" name="close" />
            </li>
          </ui>

          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">
              {{ $t("reservation.clear_order") }}
            </van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">
              {{ $t("reservation.submit") }}
            </van-button>
          </div>
        </div>
      </van-popup>

      <van-popup
          v-model="active"
          position="top"
          :style="{ height: '82%' }"
          class="history-popup-panel"
      >
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper history-popup-wrapper">
            <div
                class="history-card"
                v-for="(v, key) in lottery_list"
                :key="key"
            >
              <div class="history-card-top">
                <div class="history-card-no">NO. {{ v.expect  }}</div>
                <div class="history-card-data">数据</div>
              </div>

              <div class="history-card-result">
                <template v-if="isWaitingResult(v)">
                  <span class="history-ball waiting-ball">*</span>
                  <span class="history-ball waiting-ball">*</span>
                  <span class="history-ball waiting-ball">*</span>
                  <span class="history-ball total-ball">*</span>
                  <span class="history-tag waiting-tag">*****</span>
                </template>

                <template v-else>
                  <span
                      class="history-ball"
                      v-for="(num, idx) in getHistoryNumbers(v)"
                      :key="idx"
                  >{{ num }}</span>
                  <span class="history-ball total-ball">{{ getHistorySum(v) }}</span>
                  <span class="history-tag size-tag">{{ getHistorySizeLabel(v) }}</span>
                  <span class="history-tag odd-tag">{{ getHistoryOddEvenLabel(v) }}</span>
                </template>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>

    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">
        <div class="item" v-for="(i, index) in gameitemData" :key="index" @click="tabList(i.id, i.key)">
          <div></div>
          <div style="margin: 15px 0 0 15px;">
            <div
                style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;"
            >
              <van-image width="60" height="61" :src="i.ico" />
            </div>

            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;

export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: "",
      lily: "",
      balloon: "",
      fireworks: "",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: true,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      showBalance: true,
    };
  },
  methods: {
    back() {
      return window.history.back();
    },

    toggleHistory() {
      this.active = !this.active;
    },

    getCurrentLang() {
      return localStorage.getItem("lang") || "zh";
    },

    getLabelConfig(lang) {
      const config = {
        zh: {
          big: "玫瑰",
          small: "百合",
          odd: "烟花",
          even: "气球",
        },
        tw: {
          big: "玫瑰",
          small: "百合",
          odd: "煙花",
          even: "氣球",
        },
        en: {
          big: "Flower",
          small: "Balloon",
          odd: "Fireworks",
          even: "Lollipop",
        },
        ja: {
          big: "Bunga",
          small: "Belon",
          odd: "Bunga Api",
          even: "Lollipop",
        },
        ko: {
          big: "꽃",
          small: "풍선",
          odd: "불꽃놀이",
          even: "막대사탕",
        },
      };

      return config[lang] || config.zh;
    },

    syncLabelText() {
      const lang = this.getCurrentLang();
      const labels = this.getLabelConfig(lang);
      this.rose = labels.big;
      this.lily = labels.small;
      this.fireworks = labels.odd;
      this.balloon = labels.even;
    },

    displayPlayName(name) {
      const lang = this.getCurrentLang();
      const labels = this.getLabelConfig(lang);

      const mapping = {
        big: labels.big,
        small: labels.small,
        one: labels.odd,
        two: labels.even,
      };

      return mapping[name] || name;
    },

    getSizeLabel(sum) {
      const lang = this.getCurrentLang();
      const labels = this.getLabelConfig(lang);
      return sum >= 11 && sum <= 18 ? labels.big : labels.small;
    },

    getOddEvenLabel(sum) {
      const lang = this.getCurrentLang();
      const labels = this.getLabelConfig(lang);
      return sum % 2 === 0 ? labels.even : labels.odd;
    },

    normalizeCodeValue(val) {
      const num = Number(val);
      return isNaN(num) ? 0 : num;
    },

    hasValidOpencode(item) {
      if (!item || !item.opencode || !Array.isArray(item.opencode)) return false;
      if (item.opencode.length < 3) return false;

      const a = this.normalizeCodeValue(item.opencode[0]);
      const b = this.normalizeCodeValue(item.opencode[1]);
      const c = this.normalizeCodeValue(item.opencode[2]);

      if (a <= 0 || b <= 0 || c <= 0) return false;
      return true;
    },

    isWaitingResult(item) {
      if (!item) return true;
      if (String(item.expect) === String(this.lottery.now_expect)) return true;
      return !this.hasValidOpencode(item);
    },

    getHistoryDisplayText(item) {
      if (!this.hasValidOpencode(item)) return "*****";

      const a = this.normalizeCodeValue(item.opencode[0]);
      const b = this.normalizeCodeValue(item.opencode[1]);
      const c = this.normalizeCodeValue(item.opencode[2]);
      const sum = a + b + c;

      return this.getSizeLabel(sum) + " " + this.getOddEvenLabel(sum);
    },

    getHistoryNumbers(item) {
      if (!this.hasValidOpencode(item)) return [];
      return [
        this.normalizeCodeValue(item.opencode[0]),
        this.normalizeCodeValue(item.opencode[1]),
        this.normalizeCodeValue(item.opencode[2]),
      ];
    },

    getHistorySum(item) {
      const nums = this.getHistoryNumbers(item);
      if (!nums.length) return "*";
      return nums[0] + nums[1] + nums[2];
    },

    getHistorySizeLabel(item) {
      const sum = this.getHistorySum(item);
      if (sum === "*") return "*****";
      return this.getSizeLabel(sum);
    },

    getHistoryOddEvenLabel(item) {
      const sum = this.getHistorySum(item);
      if (sum === "*") return "*****";
      return this.getOddEvenLabel(sum);
    },

    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },

    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = true;
      this.jiesuanpage = false;
    },

    showRight() {
      this.showModel = true;
    },

    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage ? (this.jiesuanpage = false) : (this.jiesuanpage = true);
      }
    },

    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }

      if (this.formData.length >= 1) {
        this.shopchoose = "";
        this.gameitem = "";
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = true;
      }

      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },

    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }

      if (this.formData.length === 1) {
        this.shopping = true;
      }

      if (this.formData.length >= 1) {
        this.shopchoose = "";
        this.gameitem = "";
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = true;
      }
    },

    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },

    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitemData = res.data;
      });
    },

    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },

    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = this.getCurrentLang();
        const labels = this.getLabelConfig(lanng);

        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }

          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }

          if (res.data.opencode && res.data.opencode.length >= 3) {
            this.sum =
                this.normalizeCodeValue(res.data.opencode[0]) +
                this.normalizeCodeValue(res.data.opencode[1]) +
                this.normalizeCodeValue(res.data.opencode[2]);

            if (this.sum >= 11 && this.sum <= 18) {
              this.size = labels.big;
            } else if (this.sum >= 3 && this.sum <= 10) {
              this.size = labels.small;
            } else {
              this.size = "";
            }

            if (this.sum > 0) {
              if (this.sum % 2 === 0) {
                this.double = labels.even;
              } else {
                this.double = labels.odd;
              }
            } else {
              this.double = "";
            }
          } else {
            this.size = "";
            this.double = "";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.syncLabelText();
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }

    if (!localStorage.getItem("token")) {
      this.syncLabelText();
    }
  },

  computed: {
    latestResultItem() {
      const list = Array.isArray(this.lottery_list)
          ? this.lottery_list
          : Object.values(this.lottery_list || {});

      const latest = list.find((item) => !this.isWaitingResult(item) && this.hasValidOpencode(item));
      if (latest) return latest;

      if (this.hasValidOpencode(this.lottery)) return this.lottery;
      return null;
    },

    convertedShopchoose() {
      const labels = this.getLabelConfig(this.getCurrentLang());

      const mapping = {
        big: labels.big,
        small: labels.small,
        one: labels.odd,
        two: labels.even,
      };

      return this.shopchoose
          .split(",")
          .map((keyword) => mapping[keyword] || keyword)
          .join(",");
    },
  },

  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* 第一张图风格：深色背景 + 毛玻璃 + 粉红选中态
   注意：下面没有压缩原页面的字体大小，移动端 @media 也不再降低字号。 */

.lottery {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.lottery::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
      linear-gradient(180deg, rgba(18, 14, 20, 0.28) 0%, rgba(44, 25, 47, 0.58) 52%, rgba(88, 53, 83, 0.82) 100%),
      rgba(30, 20, 33, 0.3);
}

.lottery > * {
  position: relative;
  z-index: 1;
}

.lottery .van-nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 24px;
  border-radius: 10px;
  line-height: 60px;
}

.record {
  position: relative;
  margin: 10px 22px 14px;
  padding: 22px 26px 18px;
  border-radius: 24px;
  z-index: 2;
  overflow: hidden;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
      0 18px 34px rgba(0, 0, 0, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.record .period {
  display: flex;
  align-items: center;
  padding: 0 0 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.record .period::before {
  content: "\f0a4";
  font-family: "vant-icon";
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-right: 20px;
  border-radius: 50%;
  color: #fff;
  font-size: 34px;
  background: radial-gradient(circle at 35% 25%, #8fe3a2 0%, #4dbf75 72%);
  box-shadow:
      0 0 0 8px rgba(255, 255, 255, 0.08),
      0 8px 18px rgba(42, 126, 79, 0.4);
}

.record .period .period-number {
  flex: 1;
  margin-left: 0;
  margin-right: 20px;
  min-height: 58px;
  line-height: 58px;
  font-size: 34px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.3px;
}

.next-number {
  flex-shrink: 0;
  padding: 0 18px;
  border-radius: 999px;
  background: rgba(44, 39, 43, 0.82);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.van-count-down,
.next-number span {
  color: #ffe85c;
  font-size: 36px;
  font-weight: 900;
  margin-top: 0;
  float: none;
  line-height: 52px;
  letter-spacing: 1px;
}

.linear-gradient {
  display: none;
}

.history-entry-wrap {
  padding: 24px 0 0;
}

.history-entry {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 62px;
  padding: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  overflow: visible;
  cursor: pointer;
}

.history-entry::before,
.history-entry-deco,
.history-entry-center-line {
  display: none;
}

.history-entry::after {
  content: "打賞结果";
  color: #fff;
  font-size: 28px;
  font-weight: 500;
  margin-right: 18px;
}

.history-entry-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0;
}

.history-entry-right::before {
  content: "";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  margin-right: auto;
  padding: 0 14px;
  border-radius: 999px;
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
}

.history-arrow-icon {
  flex-shrink: 0;
  width: 58px;
  height: 58px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 34px !important;
  color: #fff;
  background: rgba(255, 255, 255, 0.16);
  line-height: 1;
}

.van-icon {
  font-size: 34px;
}

.down { transition: all 0.35s; }
.up { transform: rotate(180deg); transition: all 0.35s; }

.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - 80px);
  background: transparent;
}

.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 360px;
}

.sumValueTwoSides {
  display: flex;
  padding: 8px 22px 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.rectangle { overflow: hidden; }

.rectangle.large {
  width: calc(50% - 10px) !important;
  height: 180px !important;
  text-align: center;
  margin: 0 0 18px 0;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  position: relative;
  background: rgba(94, 79, 91, 0.72);
  box-shadow:
      0 10px 22px rgba(0, 0, 0, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.rectangle .wrapper {
  position: relative;
  padding: 0;
  background: transparent;
  width: 100%;
  height: 100%;
  border-radius: 18px;
}

.rectangle .wrapper .content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 35px;
  line-height: 1.2;
  margin: 0;
  font-weight: 800;
  color: #fff;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
}

.rectangle .wrapper .content .odd-text.large {
  display: block !important;
  margin: 6px 0 0;
  font-size: 30px;
  line-height: 1.2;
  color: #ff4f94;
  font-weight: 800;
  padding-top: 5px;
}

.rectangle.active,
.rectangle.active .wrapper {
  background: linear-gradient(135deg, #e56566 0%, #d83d7c 100%) !important;
  box-shadow:
      0 12px 24px rgba(216, 61, 124, 0.32),
      inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.rectangle.active .wrapper .name-text,
.rectangle.active .wrapper .odd-text {
  color: #fff !important;
}

.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 110px;
  height: 290px;
  z-index: 4;
}

.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  background: rgba(17, 17, 23, 0.96);
  box-shadow: 0 -10px 24px rgba(0, 0, 0, 0.26);
  z-index: 2;
  padding: 0 8px;
}

.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 88px;
  font-size: 20px;
}

.jixuanico {
  font-size: 42px;
  color: #fff;
}

.bottom-bar .bar .left .line {
  width: 2px;
  height: 46px;
  background: rgba(255, 255, 255, 0.16);
}

.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #fff;
}

.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff4f94;
  font-weight: 800;
}

.bottom-bar .bar .right {
  padding: 0 24px;
  margin: 0 16px;
  color: #fff;
  background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%);
  font-size: 26px;
  font-weight: 800;
  height: 66px;
  line-height: 66px;
  border-radius: 36px;
  box-shadow: 0 8px 18px rgba(227, 57, 131, 0.35);
}

.bet-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 190px;
  padding: 26px 28px 18px;
  background: rgba(26, 26, 33, 0.96);
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -10px 24px rgba(0, 0, 0, 0.18);
  z-index: 3;
  transform: none;
  opacity: 1;
  pointer-events: auto;
}

.bet-panel.active {
  transform: none;
  opacity: 1;
  pointer-events: auto;
}

.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 52px;
  padding: 6px 0;
}

.bottom-bar .wrapper .item.second-row { margin-top: 8px; }

.bottom-bar .wrapper .item .label {
  font-size: 28px;
  line-height: 1.2;
  color: #fff;
  font-weight: 800;
  white-space: nowrap;
}

.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 18px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ff4f94;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
}

.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  padding: 0 16px;
}

.van-cell {
  padding: 0;
  font-size: 28px;
  line-height: 52px;
  background: transparent;
}

::v-deep .van-field__control {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.72);
  font-weight: 700;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 30px;
}

::v-deep .van-popup { position: absolute; }
::v-deep .van-overlay { position: absolute; background-color: rgb(70 67 67 / 70%); }
::v-deep .van-popup--top { top: -1px; }

.history-popup-panel {
  border-radius: 0 0 26px 26px;
  overflow: hidden;
  background: #fff;
}

.history-popup-wrapper {
  background: #fff;
  padding: 10px 12px 34px;
  min-height: 100%;
}

.history-popup-header,
.history-popup-item {
  display: flex;
  align-items: center;
  padding: 14px 10px;
  border-bottom: 1px solid #f0f0f5;
  background: #fff;
}

.history-popup-header { padding-top: 10px; padding-bottom: 12px; }

.expect-col {
  width: 34%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.history-result-col {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
}

.wrapper .item .left {
  width: 34%;
  font-size: 28px;
  text-align: left;
  font-weight: 500;
  color: #000;
  padding-right: 14px;
  box-sizing: border-box;
  word-break: break-all;
}

.font-weight { font-weight: 700 !important; }

.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 28px;
  justify-content: flex-start;
  overflow: hidden;
  color: #000;
  word-break: break-all;
}

.history-single-line {
  width: 100%;
  font-size: 22px;
  line-height: 1.35;
  color: #111;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pending-line {
  color: #9ea0b4;
  font-weight: 700;
  letter-spacing: 2px;
}

.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.confirm-order-modal .list .lise-item .main { flex: 1; overflow: hidden; }

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 30px;
  font-weight: 500;
  line-height: 1.2;
  word-wrap: break-word;
  word-break: break-all;
  margin: 0 0 6px;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 1.35;
  font-size: 22px;
  color: #979799;
  margin: 0;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 72px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 30px;
  font-weight: 500;
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}

.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%);
  color: #fff;
  border: 0;
}

.ballBox,
.res-des { display: none; }

.list { padding: 4vw; }

.list .item {
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}

.text.num { color: #ff4f94; }
.van-icon { vertical-align: middle; }

/* 投票结果：顶部直接显示最新一期结果，不再显示空白下拉条 */
.history-entry {
  gap: 12px;
}
.history-entry::after { display: none !important; }
.history-result-left {
  flex-shrink: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 500;
}
.result-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 22px;
  line-height: 38px;
  font-weight: 800;
  color: #fff;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
}
.sum-chip { background: rgba(255, 255, 255, 0.22); }
.size-chip { background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%); }
.odd-chip { color: #333; background: linear-gradient(135deg, #e9c6f6 0%, #c897dd 100%); }
.waiting-chip { background: rgba(255, 255, 255, 0.18); }
.history-entry-right { margin-left: auto; }
.history-entry-right::before { display: none !important; }
.history-clock-icon {
  width: 58px;
  height: 58px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 36px !important;
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

/* 投票结果下拉：改成黑色卡片列表样式 */
.history-popup-panel {
  background: #19191c !important;
  border-radius: 0 !important;
}
.history-popup-wrapper {
  min-height: 100%;
  padding: 22px 28px 280px;
  background: #19191c !important;
}
.history-card {
  margin-bottom: 18px;
  padding: 20px 22px 22px;
  border-radius: 18px;
  background: #303134;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
}
.history-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.history-card-no {
  color: #fff;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 800;
}
.history-card-data {
  color: rgba(255, 255, 255, 0.58);
  font-size: 22px;
  font-weight: 500;
}
.history-card-result {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.history-ball {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  background: #55575b;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.total-ball {
  width: auto;
  min-width: 48px;
  padding: 0 10px;
  border-radius: 999px;
}
.history-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 58px;
  height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 22px;
  font-weight: 800;
  line-height: 34px;
}
.size-tag { color: #fff; background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%); }
.odd-tag { color: #303134; background: linear-gradient(135deg, #e9c6f6 0%, #c897dd 100%); }
.waiting-ball, .waiting-tag { color: rgba(255, 255, 255, 0.65); background: #55575b; }

</style>
